import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
// import { background } from '../../assets/img'

// export const ComponentName = styled('')(({theme}) => ({}))
// export const ComponentName = styled('')(({theme}) => ``);

export const PostLoginOuterWrapper = styled(Box)(`
  display: flex;
  height: 100vh;
  display: flex;
  flex-direction: column;
  @media (max-width: 1400px) {
    height: 100%;
  }
`)

export const ContentInnerWrapper = styled(Box)(`
  padding:20px;
`)
